import React, { useState } from 'react';
import Screenshot from 'sub_components/Common/Screenshot';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';
import styled from 'styled-components';
import { BugSVG } from 'sub_components/Misc/Feedback/Components/BugSVG';
import { IdeaSVG } from 'sub_components/Misc/Feedback/Components/IdeaSVG';
import { LikeSVG } from 'sub_components/Misc/Feedback/Components/LikeSVG';
const CDN_URL = process.env.REACT_APP_CDN_URL;

const bugDefault = `${CDN_URL}common/feedback/bug-default.svg`;
const ideaDefault = `${CDN_URL}common/feedback/idea-default.svg`;
const likeDefault = `${CDN_URL}common/feedback/like-default.svg`;

const FeedbackTypes = [
	{ type: 'BUG', title: 'Report a bug.' },
	{ type: 'IDEA', title: 'Send us a suggestion.' },
	{ type: 'LIKE', title: 'Tell us what you like.' },
];

function getImage(type) {
	switch (type) {
		case 'BUG':
			return bugDefault;
		case 'IDEA':
			return ideaDefault;
		case 'LIKE':
			return likeDefault;
		default:
			return ideaDefault;
	}
}

function transitionImage(type, onSelect) {
	const isEdge = !!window.StyleMedia;
	if (isEdge) {
		document.getElementById('feedback-modal-selection-screen').classList.add('windows');
	} else {
		const element = document.getElementById(`trans4-${type}`);
		if (element) {
			element.beginElement();
		}
	}
	setTimeout(() => onSelect(type), 1000);
}
function getSVG(type) {
	let SVG;
	switch (type) {
		case 'BUG':
			SVG = BugSVG;
			break;
		case 'IDEA':
			SVG = IdeaSVG;
			break;
		case 'LIKE':
			SVG = LikeSVG;
			break;
		default:
			SVG = BugSVG;
			break;
	}
	return <SVG id={type} />;
}
function hideFeedback() {
	const feedback = document.getElementById('feedback-modal-wrapper');
	feedback.classList.add('hide');
}
function showFeedback() {
	const feedback = document.getElementById('feedback-modal-wrapper');
	feedback.classList.remove('hide');
}

const FeedbackStyle = styled.div`
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;

export const SelectionScreen = ({
	setLoading,
	sendAttachment,
	sendAttachmentCG,
	onSelect,
	ticketType,
}) => {
	const [hover, setHover] = useState('');
	return (
		<FeedbackStyle className='feedback-modal-selection-screen' id='feedback-modal-selection-screen'>
			<ScrollView>
				{FeedbackTypes.map(item => (
					<div
						className={`feedback-type-wrapper ${item.type}`}
						onMouseOver={() => setHover(item.type)}
						onMouseOut={() => setHover('')}
						onClick={() => {
							transitionImage(item.type, onSelect);
						}}
						data-cy={`feedback-selection-${item.type}`}
						id={`feedback-selection-${item.type}`}
					>
						{hover !== item.type && <img src={getImage(item.type)} />}
						{hover === item.type && getSVG(item.type)}
						<div className='title forms70'>{item.title}</div>
					</div>
				))}
				<div className='screenshot-wrapper' id='screenshot-wrapper'>
					<Screenshot
						onClick={hideFeedback}
						onSelect={showFeedback}
						sendAttachmentDetails={(attachment, error) => sendAttachment(attachment, error)}
						sendAttachmentDetailsCG={(attachment, error) => sendAttachmentCG(attachment, error)}
						setLoading={setLoading}
						width={400}
						height={400}
						ticketType={ticketType}
					/>
				</div>
			</ScrollView>
		</FeedbackStyle>
	);
};
